import { render, staticRenderFns } from "./TeacherExtrasList.vue?vue&type=template&id=ac22b68a&scoped=true"
import script from "./TeacherExtrasList.vue?vue&type=script&lang=js"
export * from "./TeacherExtrasList.vue?vue&type=script&lang=js"
import style0 from "./TeacherExtrasList.vue?vue&type=style&index=0&id=ac22b68a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac22b68a",
  null
  
)

export default component.exports